import React from "react";
import PropTypes from "prop-types";
import IconBase from "./IconBase";

function SpeakerLightIcon(props) {
  return (
    <IconBase {...props}>
      <rect
        width="2"
        height="4"
        x="74"
        y="40"
        fill={props.pathColor || "#8896A4"}
        rx="1"
      ></rect>
      <rect
        width="2"
        height="8"
        x="77"
        y="38"
        fill={props.pathColor || "#8896A4"}
        rx="1"
      ></rect>
      <rect
        width="2"
        height="4"
        x="80"
        y="40"
        fill={props.pathColor || "#8896A4"}
        rx="1"
      ></rect>
    </IconBase>
  );
}

SpeakerLightIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  strokeColor: PropTypes.string,
  pathColor: PropTypes.string,
};

export default SpeakerLightIcon;
